export const CHILDREN_COMPONENT_NAMES = {
  message: "Message",
  mailOrderPharmacyAddress: "MailOrderPharmacyAddress",
  consenter: "Consenter",
  address: "Address",
  invoice: "Invoice",
  doctor: "Doctor"
};

export const isMessageValid = ({ message_id = null }) => {
  return typeof message_id === "number" && message_id > -1;
};
